import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  WorkTimeCategoriesContractTaxonomyFragment,
  WorkTimeCategoriesReimbursableSupplementTaxonomyFragment,
} from 'generated/resources/graphql'
import { groupBy } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ReimbursableTaxonomiesMappingForm } from 'modules/attendance/lib/forms/utils/CustomTimeRangesFormData'

import TaxonomySelect from './TaxonomySelect'

interface Props {
  timeSettingsCategoryId?: number
  contractsTaxonomies: WorkTimeCategoriesContractTaxonomyFragment[]
  payrollMappingsTaxonomies: WorkTimeCategoriesReimbursableSupplementTaxonomyFragment[]
  formMappingsTaxonomies: ReimbursableTaxonomiesMappingForm[]
  onChange: (props: { taxonomyId: string; legalEntityId: number; mappingId?: string }) => void
}

const PayrollMappings = ({
  timeSettingsCategoryId,
  contractsTaxonomies,
  payrollMappingsTaxonomies,
  formMappingsTaxonomies,
  onChange,
}: Props) => {
  const { company } = useCurrentSession()
  const { legalEntities } = company

  const taxonomiesByLegalEntity = groupBy(
    contractsTaxonomies.filter((taxonomy) => !taxonomy.archived),
    (taxonomy) => taxonomy.legalEntityId
  )

  const mappingsGrouped = groupBy(
    payrollMappingsTaxonomies,
    (mapping) => `${mapping.legalEntityId}_${mapping.reimbursableId}`
  )

  const formMappingsGrouped = groupBy(
    formMappingsTaxonomies,
    (mapping) => `${mapping.legalEntityId}_${mapping.timeRangeCategoryId}`
  )

  return (
    <Box gap="s16">
      <Text.Normal>
        {i18n.t(
          'time_tracking.settings.time_blocks.categories.special_hours.wizard.compensation_method.payroll_taxonomy_title'
        )}
      </Text.Normal>
      {legalEntities.map((legalEntity) => {
        return (
          <TaxonomySelect
            key={legalEntity.id}
            legalEntityId={legalEntity.id}
            legalEntityName={legalEntity.legalName}
            taxonomiesByLegalEntity={taxonomiesByLegalEntity}
            mappingsGrouped={mappingsGrouped}
            formMappingsGrouped={formMappingsGrouped}
            timeSettingsCategoryId={timeSettingsCategoryId}
            onChange={onChange}
          />
        )
      })}
    </Box>
  )
}

export default PayrollMappings
